import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const nodeCategories = [
  {
    name: 'Démarrage & Entrée',
    icon: 'Play',
    color: '#10b981',
    nodes: [
      { type: 'start', label: 'Démarrer', icon: 'Play', color: '#10b981', defaultConfig: {} },
      { type: 'document_upload', label: 'Charger Document', icon: 'Upload', color: '#10b981', defaultConfig: {} },
      { type: 'manual_input', label: 'Saisie Manuelle', icon: 'Edit3', color: '#10b981', defaultConfig: {} },
      { type: 'api_trigger', label: 'Déclencheur API', icon: 'Zap', color: '#10b981', defaultConfig: {} },
      { type: 'schedule', label: 'Planificateur', icon: 'Clock', color: '#10b981', defaultConfig: {} },
    ],
  },
  {
    name: 'Analyse de Documents',
    icon: 'FileText',
    color: '#3b82f6',
    nodes: [
      { type: 'document_analysis', label: 'Analyse de Document', icon: 'FileSearch', color: '#3b82f6', defaultConfig: { analysisType: 'standard' } },
      { type: 'document_comparison', label: 'Comparaison Documents', icon: 'GitCompare', color: '#3b82f6', defaultConfig: {} },
      { type: 'bulk_processing', label: 'Traitement en Masse', icon: 'Layers', color: '#3b82f6', defaultConfig: { analysisType: 'standard' } },
      { type: 'ocr', label: 'OCR / Extraction Texte', icon: 'ScanText', color: '#3b82f6', defaultConfig: {} },
      { type: 'document_classification', label: 'Classification Document', icon: 'Tags', color: '#3b82f6', defaultConfig: {} },
      { type: 'risk_assessment', label: 'Évaluation des Risques', icon: 'AlertTriangle', color: '#3b82f6', defaultConfig: {} },
    ],
  },
  {
    name: 'Contrats',
    icon: 'FileSignature',
    color: '#8b5cf6',
    nodes: [
      { type: 'contract_drafting', label: 'Rédaction de Contrat', icon: 'FileSignature', color: '#8b5cf6', defaultConfig: { template: 'NDA' } },
      { type: 'contract_review', label: 'Révision de Contrat', icon: 'FileCheck', color: '#8b5cf6', defaultConfig: {} },
      { type: 'clause_extraction', label: 'Extraction de Clauses', icon: 'ListFilter', color: '#8b5cf6', defaultConfig: {} },
      { type: 'clause_improvement', label: 'Amélioration de Clause', icon: 'Sparkles', color: '#8b5cf6', defaultConfig: {} },
      { type: 'template_selection', label: 'Sélection de Modèle', icon: 'Library', color: '#8b5cf6', defaultConfig: {} },
    ],
  },
  {
    name: 'IA & Recherche',
    icon: 'Brain',
    color: '#f59e0b',
    nodes: [
      { type: 'legal_chat', label: 'Assistant Juridique IA', icon: 'MessageSquare', color: '#f59e0b', defaultConfig: { mode: 'standard' } },
      { type: 'legal_research', label: 'Recherche Légale', icon: 'Search', color: '#f59e0b', defaultConfig: { sources: ['legifrance', 'eurlex'] } },
      { type: 'compliance_check', label: 'Vérification Conformité', icon: 'ShieldCheck', color: '#f59e0b', defaultConfig: { regulation: 'RGPD' } },
      { type: 'due_diligence', label: 'Due Diligence', icon: 'CheckSquare', color: '#f59e0b', defaultConfig: {} },
      { type: 'precedent_search', label: 'Recherche Jurisprudence', icon: 'Scale', color: '#f59e0b', defaultConfig: {} },
    ],
  },
  {
    name: 'Veille Légale',
    icon: 'Bell',
    color: '#ec4899',
    nodes: [
      { type: 'legal_watch', label: 'Surveiller Actualités', icon: 'Bell', color: '#ec4899', defaultConfig: { domains: [] } },
      { type: 'filter_domain', label: 'Filtrer par Domaine', icon: 'Filter', color: '#ec4899', defaultConfig: {} },
      { type: 'alert_changes', label: 'Alerte Changements', icon: 'BellRing', color: '#ec4899', defaultConfig: {} },
      { type: 'impact_analysis', label: 'Analyse d\'Impact', icon: 'TrendingUp', color: '#ec4899', defaultConfig: {} },
    ],
  },
  {
    name: 'Collaboration',
    icon: 'Users',
    color: '#06b6d4',
    nodes: [
      { type: 'add_comment', label: 'Ajouter Commentaire', icon: 'MessageCircle', color: '#06b6d4', defaultConfig: {} },
      { type: 'request_approval', label: 'Demander Approbation', icon: 'UserCheck', color: '#06b6d4', defaultConfig: {} },
      { type: 'send_notification', label: 'Envoyer Notification', icon: 'Send', color: '#06b6d4', defaultConfig: {} },
      { type: 'assign_task', label: 'Assigner Tâche', icon: 'UserPlus', color: '#06b6d4', defaultConfig: {} },
      { type: 'share_document', label: 'Partager Document', icon: 'Share2', color: '#06b6d4', defaultConfig: {} },
    ],
  },
  {
    name: 'Logique & Contrôle',
    icon: 'GitBranch',
    color: '#64748b',
    nodes: [
      { type: 'condition', label: 'Condition (Si/Alors)', icon: 'GitBranch', color: '#64748b', defaultConfig: { operator: 'equals' } },
      { type: 'loop', label: 'Boucle / Itération', icon: 'Repeat', color: '#64748b', defaultConfig: {} },
      { type: 'delay', label: 'Délai / Attente', icon: 'Timer', color: '#64748b', defaultConfig: { duration: 60 } },
      { type: 'merge', label: 'Fusionner Chemins', icon: 'Merge', color: '#64748b', defaultConfig: {} },
      { type: 'split', label: 'Diviser Chemins', icon: 'Split', color: '#64748b', defaultConfig: {} },
    ],
  },
  {
    name: 'Sortie & Export',
    icon: 'Download',
    color: '#ef4444',
    nodes: [
      { type: 'export_document', label: 'Exporter Document', icon: 'Download', color: '#ef4444', defaultConfig: { format: 'PDF' } },
      { type: 'send_email', label: 'Envoyer Email', icon: 'Mail', color: '#ef4444', defaultConfig: { action_type: 'email', to: '', subject: '', body: '' } },
      { type: 'save_database', label: 'Sauvegarder en BD', icon: 'Database', color: '#ef4444', defaultConfig: {} },
      { type: 'generate_report', label: 'Générer Rapport', icon: 'FileOutput', color: '#ef4444', defaultConfig: {} },
      { type: 'end', label: 'Terminer', icon: 'StopCircle', color: '#ef4444', defaultConfig: {} },
    ],
  },
];

const NodePalette = () => {
  const [expandedCategories, setExpandedCategories] = useState(
    nodeCategories.reduce((acc, cat) => ({ ...acc, [cat.name]: true }), {})
  );
  const [searchTerm, setSearchTerm] = useState('');

  const toggleCategory = (categoryName) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  const onDragStart = (event, nodeData) => {
    event.dataTransfer.setData('application/reactflow', JSON.stringify(nodeData));
    event.dataTransfer.effectAllowed = 'move';
  };

  const filteredCategories = nodeCategories.map((category) => ({
    ...category,
    nodes: category.nodes.filter((node) =>
      node.label.toLowerCase().includes(searchTerm.toLowerCase())
    ),
  })).filter((category) => category.nodes.length > 0);

  return (
    <div className="w-80 bg-white border-r border-gray-200 flex flex-col h-full">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-lg font-bold text-gray-900 mb-3">Palette de Nœuds</h2>
        <input
          type="text"
          placeholder="Rechercher un nœud..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      {/* Categories */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {filteredCategories.map((category) => {
          const CategoryIcon = Icons[category.icon] || Icons.Circle;
          return (
            <div key={category.name} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleCategory(category.name)}
                className="w-full px-3 py-2 bg-gray-50 hover:bg-gray-100 flex items-center justify-between transition-colors"
              >
                <div className="flex items-center gap-2">
                  <CategoryIcon className="w-4 h-4" style={{ color: category.color }} />
                  <span className="font-semibold text-sm text-gray-900">{category.name}</span>
                  <span className="text-xs text-gray-500">({category.nodes.length})</span>
                </div>
                {expandedCategories[category.name] ? (
                  <ChevronDown className="w-4 h-4 text-gray-500" />
                ) : (
                  <ChevronRight className="w-4 h-4 text-gray-500" />
                )}
              </button>

              {expandedCategories[category.name] && (
                <div className="p-2 space-y-1 bg-white">
                  {category.nodes.map((node) => {
                    const NodeIcon = Icons[node.icon] || Icons.Circle;
                    return (
                      <div
                        key={node.type}
                        draggable
                        onDragStart={(e) => onDragStart(e, node)}
                        className="px-3 py-2 rounded-md border border-gray-200 hover:border-gray-300 hover:shadow-sm cursor-move bg-white transition-all flex items-center gap-2"
                      >
                        <div
                          className="p-1 rounded"
                          style={{ backgroundColor: `${node.color}20` }}
                        >
                          <NodeIcon className="w-3.5 h-3.5" style={{ color: node.color }} />
                        </div>
                        <span className="text-sm text-gray-700">{node.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer Help */}
      <div className="p-4 bg-indigo-50 border-t border-indigo-200">
        <p className="text-xs text-indigo-900 font-semibold mb-1 flex items-center gap-1.5"><Icons.Lightbulb className="h-3.5 w-3.5" /> Astuce</p>
        <p className="text-xs text-indigo-700">
          Glissez-déposez les nœuds sur le canvas pour construire votre workflow. Connectez-les pour créer un flux logique.
        </p>
      </div>
    </div>
  );
};

export default NodePalette;
